import { useMutation, gql } from '@apollo/client';
import {
  DeletarPeriodoMutation,
  DeletarPeriodoMutationVariables,
} from './__generated__/DeletarPeriodoMutation';

const DELETAR_PERIODO_MUTATION = gql`
  mutation DeletarPeriodoMutation($id_periodo: Int!) {
    deletarPeriodo(id_periodo: $id_periodo) {
      id_periodo
    }
  }
`;

const useDeletarPeriodoMutation = () => {
  return useMutation<DeletarPeriodoMutation, DeletarPeriodoMutationVariables>(
    DELETAR_PERIODO_MUTATION
  );
};

export { useDeletarPeriodoMutation };
